import { useState, useEffect } from "react";
import Pagination from "components/common/pagination";

import IKeyssukListProps from "types/micro";
import { apiPost } from "apis/api";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import {Swiper, SwiperClass, SwiperSlide} from 'swiper/react';
import { Autoplay, Grid, Navigation, Scrollbar } from 'swiper/modules';

import 'assets/css/board.scss';
import 'swiper/css';
import 'swiper/css/navigation'; 

const ApplyList = () => {
  const [dataList, setDataList] = useState<IKeyssukListProps[]>([]);
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  const paramData = {
    strType : "C"
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiPost('/micro/member/getApplyList', JSON.stringify(paramData)) as { resultList: IKeyssukListProps[] };
        setDataList(response.resultList);
        console.log(response.resultList);
        if (response.resultList.length > 0) {
          
        }

      } catch (error) {
        console.error(axios.isAxiosError(error) ? error.message : error);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();

  
    return (
      <div id="apply-list" className="applyList">
        <Swiper 
          slidesPerView={5}
          spaceBetween={5}
          speed={1000}
          direction={'vertical'}
          modules={[Autoplay]}
          loop={true}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            
          }}
          //touchRatio = {0}
        >
        {
          dataList?.map((item, index) => {
          
              return (
                <SwiperSlide key={index}>
                <div className="applyItem" key={index}>
                  <div>{item.MemberName}</div>
                  <div>{item.Gender === "M" ? "남성" : "여성"}</div>
                  <div>{item.MemberCell}</div>
                  <div>신청완료</div>
                </div>
                </SwiperSlide>
              );
          
            return null;
          })
        }
        </Swiper>
      </div>
    );
  
};

export default ApplyList;
